import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var DoneFilled = function DoneFilled(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM9.84733 15.6651L7.31234 12.9007C6.89589 12.4544 6.89589 11.7309 7.31234 11.2847C7.7288 10.8384 8.40387 10.8384 8.82033 11.2847L10.6013 13.2411L15.1797 8.33472C15.5961 7.88843 16.2712 7.88843 16.6877 8.33472C17.1041 8.78101 17.1041 9.50446 16.6877 9.95075L11.3553 15.6651C11.157 15.8783 10.8823 16 10.6013 16C10.3203 16 10.0457 15.8783 9.84733 15.6651Z",
    fill: color
  }));
};

export { DoneFilled };
